import React from "react";
import { useQuery } from "react-query";
import { getAssignUsers } from "./gateway";

export default function useGetAssignUsers({
  case_id,
  enabled,
}: {
  case_id: number;
  enabled: boolean;
}) {
  return useQuery({
    queryFn: () => getAssignUsers(case_id),
    queryKey: ["chamber_users", case_id],
    enabled: !!enabled,
  });
}
